module.exports = __webpack_public_path__ + "img/icon_downward.11e0ef23.svg";